module.exports = "/dist/b20cc131034316b1c85d0498fb9ed5c5.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-400.woff
// module id = 120
// module chunks = 0